import React, {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {
    Paper, Typography, Chip, Tabs, Tab, Divider, FormControlLabel, Switch
} from '@material-ui/core';
import { getLicensesBillingSummary } from "../../../services/billing.service";
import { BillingStats, InsidersList } from "./components";


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    tabContainer: {
        marginBottom: theme.spacing(3),
    },
    tabContent: {
        paddingTop: theme.spacing(2),
    },
    configSection: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.spacing(1),
    },
}));


function LicensesBilling_ORG() {
    const classes = useStyles();

    // Tab state (only Dashboard tab available now)
    const [activeTab, setActiveTab] = useState(0);

    // Dashboard data
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState(null);
    
    // DQW visibility toggle
    const [showDQW, setShowDQW] = useState(false);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setDashboardLoading(true);
        try {
            const result = await getLicensesBillingSummary();
            if (result && result.data) {
                setDashboardData(result.data);
            } else {
                console.error('Failed to fetch dashboard data');
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setDashboardLoading(false);
        }
    };


    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Container component="main" maxWidth='false'>
            <div className={classes.paper}>
                <h3>Organization Licenses Billing</h3>
            </div>

            {/* Tab Navigation - Organization Details tab disabled */}
            <Paper className={classes.tabContainer}>
                <Tabs 
                    value={activeTab} 
                    onChange={handleTabChange} 
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Dashboard" />
                    {/* <Tab label="Organization Details" /> */}
                </Tabs>
            </Paper>

            <div className={classes.tabContent}>
                {/* Dashboard Tab */}
                {activeTab === 0 && (
                    <Paper style={{ padding: 24 }}>
                        {/* Configuration Section */}
                        <Paper className={classes.configSection} elevation={1}>
                            <Typography variant="subtitle1" gutterBottom>
                                Display Configuration
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showDQW}
                                        onChange={(e) => setShowDQW(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Show DQ World (DQW) Counts"
                            />
                        </Paper>
                        
                        {dashboardData && (
                            <>
                                <BillingStats summary={dashboardData.summary} showDQW={showDQW} />
                                
                                <Divider style={{ margin: '24px 0' }} />
                                
                                <InsidersList 
                                    insiders={dashboardData.insiders} 
                                    onDataUpdate={fetchDashboardData}
                                    showDQW={showDQW}
                                />
                            </>
                        )}
                        <LoaderWithBackDrop loading={dashboardLoading} />
                    </Paper>
                )}

                {/* Organization Details Tab - DISABLED */}
                {/* Tab content removed as Organization Details tab is disabled */}
            </div>
        </Container>
    );
}

export default LicensesBilling_ORG;
